import * as React from "react";
import DataGrid from "../app/grid/DataGrid";
import { IEvaluationRuleGroup } from "../../../model/evaluation/EvaluationRuleGroup";
import { Spin } from "antd";
import { IEvaluationBusinessRule } from "../../../model/evaluation/EvaluationBusinessRule";
import EvaluationBusinessRulesGrid from "./EvaluationBusinessRulesGrid";

export interface Props {
  translate: any;
  evaluationRuleGroups: IEvaluationRuleGroup[];
  isLoading: boolean;
  onRuleGroupExpand: any;
  evaluationBusinessRules: IEvaluationBusinessRule[];
  evaluationBusinessRuleLoader: boolean;
}

export interface State {}

export default class EvaluationReviewRuleGroupsGrid extends React.Component<
  Props,
  State
> {
  render() {
    const {
      translate,
      evaluationRuleGroups,
      isLoading,
      onRuleGroupExpand,
      evaluationBusinessRules,
      evaluationBusinessRuleLoader
    } = this.props;

    const columns = [
      {
        title: translate("evaluation_review_rule_groups_grid.group_name"),
        dataIndex: "businessRuleGroupName",
        key: "businessRuleGroupName"
      },
      {
        title: translate("evaluation_review_rule_groups_grid.description"),
        dataIndex: "businessRuleGroupDescription",
        key: "businessRuleGroupDescription"
      },
      {
        title: translate(
          "evaluation_review_rule_groups_grid.difficulty_factor"
        ),
        dataIndex: "businessRuleGroupEvaluationDifficultyFactor",
        key: "businessRuleGroupEvaluationDifficultyFactor"
      },
      {
        title: translate(
          "evaluation_review_rule_groups_grid.difficulty_threshold"
        ),
        dataIndex: "difficultyThreshold",
        key: "difficultyThreshold"
      },
      {
        title: translate(
          "evaluation_review_rule_groups_grid.evaluation_result"
        ),
        dataIndex: "businessRuleGroupEvaluationResult",
        key: "businessRuleGroupEvaluationResult"
      },
      {
        title: translate("evaluation_review_rule_groups_grid.error_log"),
        dataIndex: "errorLog",
        key: "errorLog"
      }
    ];

    const expandedRowRender = e => {
      return (
        <EvaluationBusinessRulesGrid
          translate={translate}
          evaluationBusinessRules={evaluationBusinessRules}
          isLoading={evaluationBusinessRuleLoader}
        />
      );
    };

    return (
      <Spin spinning={isLoading}>
        <DataGrid
          title={translate("evaluation_review_rule_groups_grid.title")}
          columns={columns}
          translate={translate}
          dataSource={evaluationRuleGroups}
          onExpand={onRuleGroupExpand}
          expandedRowRender={expandedRowRender}
          singleRowExpandEnabled
        />
      </Spin>
    );
  }
}
